'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var wixResultInterceptor = function wixResultInterceptor(response) {
  // Do something with response data
  if (response.data) {
    if (response.data.success === false) {
      response.status = 500;
      return Promise.reject(response);
    } else if (response.data.success === true && response.data.payload !== undefined) {
      var payload = response.data.payload;
      if ((typeof payload === 'undefined' ? 'undefined' : _typeof(payload)) === 'object' && !Array.isArray(payload)) {
        delete response.data.payload;
        delete response.data.success;
        delete response.data.errorCode;
        delete response.data.errorDescription;
        response.data = Object.assign(response.data, payload);
      } else {
        response.data = response.data.payload;
      }
    }
  }
  return response;
};

exports.default = { responseSuccess: wixResultInterceptor };
//# sourceMappingURL=axios-intercept-wix-result.js.map



//////////////////
// WEBPACK FOOTER
// ../~/wix-axios-config/dist/src/axios-intercept-wix-result.js
// module id = 865
// module chunks = 0